import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import img from "../../../assets/img/Home/cover-img (4).png";
import money from "../../../assets/img/icons/money-4.svg";
import star from "../../../assets/img/icons/star.svg";
import useFetch from '../../../hooks/useAxios';
import Button from "../../shared/Button"
import PersianNumber from '../../shared/PersianNumber';
const ResidenceDetailBos = ({inforesidencedetail,reserveinfodetail,isReserveSuccess}) => {
  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
  const {id}=useParams()
const navigate = useNavigate()
  const apipayment = useFetch({
    method: "post",
    url: `api/guest/un-instant/${id}`,
    noHeader: false,
    trigger: false,
   data:{
    gateway:"zarinpal"
   },
   argFunc:(res)=>{
    window.location.replace(res.data)
   }
  });
  const payment = ()=>{
    apipayment.reFetch()
  }
  return (
    <div className='ResidenceDetailBos'>
      <div className='flex items-center gap-[24px]'>
        <img src={inforesidencedetail?.thumbnail?.path}  className='ResidenceDetailBos--img'/>
        <div>
        <div className="center w-max py-[6px] px-[16px] bg-[#F1C31F] rounded-[50px] text-[16px] font-[600] text-[#12171C] flex justify-center items-center">
        <p className="">
          کد آگهی :
        </p>
        <p>
          <PersianNumber number={inforesidencedetail.code} />
        </p>
      </div>

          <h3>{inforesidencedetail.title}</h3>
        </div>
      </div>
      <div className='flex items-center gap-[8px] ResidenceDetailBos-cost'>
        <img src={money}/>
        <p >قیمت هر شب :</p>
      </div>
      
      <div className='flex justify-between items-end pb-[30px] '>
      <div className="flex price-box justify-end">
          <div className="pre-cost ml-[4px]">از</div>

          <div className="cost">
           <PersianNumber number={inforesidencedetail.price}/>
          </div>
          <div className="pre-cost">تومان</div>
        </div>
        <div className="d-flex-align mt-[19px] ">
        

        <div className="text-[#12171C] text-[20px] mb-[-7px] font-[900]">
         <PersianNumber  number={round(inforesidencedetail.rating_value, 1)} />
          
        </div>
        <img src={star} className="mr-[5px]" />
      </div>


      </div>
      <hr/>
      <div className='ResidenceDetailBos--dayscost d-flex-space py-[36px]'>
        <p><PersianNumber number={reserveinfodetail.count_days} /> شب اقامت</p>
        <div><PersianNumber number={reserveinfodetail.amount} /> تومان</div>
      </div>
      <hr/>
      <div className='ResidenceDetailBos--totalcost d-flex-space py-[36px]'>
        <p>
        جمع مبلغ قابل پرداخت
        </p>
        <div>
        <PersianNumber number={reserveinfodetail.final_amount} /> تومان
        </div>
      </div>
    <div className='flex gap-[20px]'>
      <Button onClick={payment} disabled={isReserveSuccess !== "تایید شده"} varient="primary" fullwidth={true}  >پرداخت صورت حساب</Button>
    </div>
      
    </div>
  )
}

export default ResidenceDetailBos